import React, { useContext, useEffect, useState } from "react";
import { LinearProgress, Tab, Tabs  } from "@mui/material";

import WebhookAddComponent from "./webhook-add";
import TableLayout from "../table-layout/hoa-table-layout";
import SuccessMessage from "../success-message/hoa-success-message";
import UrlParamsService from "../../services/hoa-url-params-service";
import { GlobalContext } from "../../context/hoa-global-context";

import config from "../../hoa-config";
import datastore from "../../store/hoa-datastore";
import dashboardServices from "../../services/hoa-dashboard-api-service";

export default function TriggerNotification() {
    const { activeTab, updateActiveTab, selectedValues,updateSelectedValues, triggerNotifications, updateTriggerNotificationData,  triggerNotificationLogs, updateTriggerNotificationLogsData } = useContext<any>(GlobalContext)
    const [view, setView] = useState('list');
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);

    const webhookUrlHeaders = config.dashboard["Webhook"]?.tableLayout?.title;
    const webhookUrlColumns = config.dashboard["Webhook"]?.tableLayout?.columns;

    const filteringTitle = config.dashboard["Webhook"]?.filterComponent?.title;
    const filteringSubTitle = config.dashboard["Webhook"]?.filterComponent?.subTitle;

    const triggerNotificationLogHeaders = config.dashboard["TriggerNotificationLog"]?.tableLayout?.title;
    const triggerNotificationLogColumns = config.dashboard["TriggerNotificationLog"]?.tableLayout?.columns;

    const getWebhookUrls = async (numberOfNotifications: number, pageNo: number) => {
        setLoading(true);
        const { data } = await dashboardServices.getWebhookUrls(numberOfNotifications, pageNo);
        setLoading(false);

        return {
            data: data.triggerNotifications,
            count: data.parseCount
        };
    }

    const getTriggerNotificationLogs = async (numberOfLogs: number, pageNo: number) => {
        setLoading(true);
        const { data } = await dashboardServices.getTriggerNotificationLogs(numberOfLogs, pageNo, triggerNotificationLogs.options);
        setLoading(false);

        return {
            data: data.triggerNotificationLogs,
            count: data.parseCount
        };
    }

    const retryWebhook = async (logData:any) => {
        const {
            objectId,
            appLogsId,
            triggerNotificationId
        } = logData;
        
        if (objectId && appLogsId) {
            setLoading(true);
            const response:any = await dashboardServices.retryWebhook(objectId, appLogsId, triggerNotificationId);
            setLoading(false);

            if (response.status == 200) {
                const copyOfTriggerNotificationLogsData = JSON.parse(JSON.stringify(triggerNotificationLogs.data));

                let updateIndex = -1;
                for (let index = 0; index < copyOfTriggerNotificationLogsData.length; index++) {
                    if (copyOfTriggerNotificationLogsData[index].objectId === objectId) {
                        updateIndex = index;
                    }
                }

                if (updateIndex > -1) {
                    copyOfTriggerNotificationLogsData[updateIndex] = response.data;
                }

                updateTriggerNotificationLogsData({
                    ...triggerNotificationLogs,
                    data: copyOfTriggerNotificationLogsData
                });        
            }
        }
    }

    const onStatusFilterChange = (event:any) => {
        var options = {
            [event.target.name]: event.target.value
        }
        
        updateTriggerNotificationLogsData({
            ...triggerNotificationLogs,
            data: [],
            pageNumber: 1,
            options: options,
            isLastPage: false,
            fetchingFilteredData: true,
        });
    }

    return (
        <>
            <WebhookAddComponent
                title={filteringTitle}
                subTitle={filteringSubTitle}
                tagType={"Webhook"}
                activeTab={activeTab}
                loading={loading}
                setLoading={setLoading}
                open={open}
                setOpen={setOpen}
                selectedValues={selectedValues}
                updateSelectedValues={updateSelectedValues}
                onStatusFilterChange={onStatusFilterChange}
            />
            <div style={{ borderBottom: "1px solid #E8E8E8" }}>
                <Tabs
                    value={activeTab}
                    onChange={(event, value) => {
                        updateActiveTab(value);
                    }}
                >
                    {config.webhookTabTitles
                        .map((title: string, index: number) => {
                            return (
                                <Tab
                                    key={index}
                                    label={title}
                                    value={index}
                                    style={{ minWidth: "143px", textTransform: "none" }}
                                />
                            );
                        })
                        .filter((value: any) => value !== undefined)}
                </Tabs>
                <div>
                    {activeTab === 0 ?
                        <TableLayout
                            fetchResult={getWebhookUrls}
                            headers={webhookUrlHeaders}
                            columns={webhookUrlColumns}
                            tagType={"Webhook"}
                            updateView={setView}
                            updateSelectedValues={updateSelectedValues}
                            editModalOpen={open}
                            setEditModalOpen={setOpen}
                        />
                        :
                        <></>
                    }
                    {activeTab === 1 ?
                        <TableLayout
                            fetchResult={getTriggerNotificationLogs}
                            headers={triggerNotificationLogHeaders}
                            columns={triggerNotificationLogColumns}
                            tagType={"TriggerNotificationLog"}
                            updateView={setView}
                            updateSelectedValues={updateSelectedValues}
                            editModalOpen={open}
                            setEditModalOpen={setOpen}
                            retryWebhook={retryWebhook}
                        />
                        :
                        <></>
                    }
                </div>
                <SuccessMessage
                    success={success}
                    setSuccess={setSuccess}
                    message={message}
                />
            </div>
        </>
    )
}
